import { render, staticRenderFns } from "./map_sign.vue?vue&type=template&id=8ae32c04&scoped=true"
import script from "./map_sign.vue?vue&type=script&lang=js"
export * from "./map_sign.vue?vue&type=script&lang=js"
import style0 from "./map_sign.vue?vue&type=style&index=0&id=8ae32c04&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae32c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae32c04')) {
      api.createRecord('8ae32c04', component.options)
    } else {
      api.reload('8ae32c04', component.options)
    }
    module.hot.accept("./map_sign.vue?vue&type=template&id=8ae32c04&scoped=true", function () {
      api.rerender('8ae32c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/map_sign.vue"
export default component.exports